import { JobLinkedinPlacement } from 'lib/enum/job-linkedin-placement.enum';
import { JobFacebookPlacement } from './job-facebook-placement.enum';
import { JobInstagramPlacement } from './job-instagram-placement.enum';
import { JobMessengerPlacement } from './job-messenger-placement.enum';
import { JobPlatformType } from './job-platform-type.enum';

export enum JobCampaignObjective {
    Traffic = 'traffic',
    Conversion = 'conversion',
    LeadGeneration = 'lead_generation',
}

export const getObjectiveDisplayName = (objective: JobCampaignObjective): string =>
    JobCampaignObjectiveToNameMap.get(objective) ?? (objective as string);

const JobCampaignObjectiveToNameMap = new Map<JobCampaignObjective, string>([
    [JobCampaignObjective.Traffic, 'Traffic'],
    [JobCampaignObjective.Conversion, 'Conversion'],
    [JobCampaignObjective.LeadGeneration, 'Lead Generation'],
]);

export type JobPlacement = JobFacebookPlacement | JobInstagramPlacement | JobMessengerPlacement | JobLinkedinPlacement;

interface UniqueJobsPlacement {
    placement: JobPlacement;
    platformType: JobPlatformType;
}

const getCompatiblePlacements = (): UniqueJobsPlacement[] => [
    { placement: JobFacebookPlacement.NewsFeed, platformType: JobPlatformType.Facebook },
    { placement: JobFacebookPlacement.Stories, platformType: JobPlatformType.Facebook },
    { placement: JobFacebookPlacement.SearchResults, platformType: JobPlatformType.Facebook },
    { placement: JobFacebookPlacement.InStreamVideos, platformType: JobPlatformType.Facebook },
    { placement: JobFacebookPlacement.Marketplace, platformType: JobPlatformType.Facebook },
    { placement: JobFacebookPlacement.RightColumn, platformType: JobPlatformType.Facebook },
    { placement: JobFacebookPlacement.Reels, platformType: JobPlatformType.Facebook },
    { placement: JobInstagramPlacement.Stories, platformType: JobPlatformType.Instagram },
    { placement: JobInstagramPlacement.Explore, platformType: JobPlatformType.Instagram },
    { placement: JobInstagramPlacement.Feed, platformType: JobPlatformType.Instagram },
    { placement: JobInstagramPlacement.Reels, platformType: JobPlatformType.Instagram },
    { placement: JobMessengerPlacement.Stories, platformType: JobPlatformType.Messenger },
    { placement: JobMessengerPlacement.Inbox, platformType: JobPlatformType.Messenger },
    { placement: JobLinkedinPlacement.SponsoredUpdates, platformType: JobPlatformType.Linkedin },
];

export const isPlacementCompatibleToObjective = (jobCampaignPlacement: UniqueJobsPlacement): boolean => {
    const compatiblePlacements = getCompatiblePlacements();
    return compatiblePlacements.some(
        compatiblePlacement =>
            compatiblePlacement.placement === jobCampaignPlacement.placement &&
            compatiblePlacement.platformType === jobCampaignPlacement.platformType,
    );
};
